import React, { useState } from 'react';
import { type IconType } from 'react-icons';

import { SectionFAQ } from '@/types/props';

import Answer from './Answer';
import Question from './Question';

const Section: React.FC<SectionFAQ & { icon: IconType }> = ({
  answer,
  icon,
  index,
  question,
}) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  return (
    <article
      className={`overflow-hidden rounded-2xl border bg-white/80 shadow-[0_10px_32px_rgba(9,45,54,0.06)] backdrop-blur-sm transition-all duration-300 ${
        isActive
          ? 'border-greenSecondary/25 shadow-[0_16px_40px_rgba(68,148,134,0.12)]'
          : 'border-white/80 hover:border-greenSecondary/15 hover:shadow-[0_14px_36px_rgba(9,45,54,0.08)]'
      }`}
    >
      <Question
        icon={icon}
        index={index}
        isActive={isActive}
        onClick={() => setIsActive((active) => !active)}
        question={question}
      />
      <Answer answer={answer} index={index} isActive={isActive} />
    </article>
  );
};

export default Section;
